import {
  faEye,
  faEyeSlash,
  faRightFromBracket,
  faUser,
  faUsers,
  faClipboardList,
  faScaleUnbalanced,
  faPenToSquare,
  faTrashCan,
  faPlus,
  faXmark,
  faBullseye,
  faGear,
  faCommentDots,
  faChartColumn,
  faCartShopping,
  faEarthAmericas,
  faUpload,
  faListCheck,
  faLock,
  faImagePortrait,
  faTable,
  faTableCells,
  faStar as faStarSolid,
  faArrowLeft,
  faEllipsisVertical,
  faPaperclip,
  faCamera,
  faPaperPlane,
  faCircleCheck as faCircleCheckSolid,
  faVideo,
  faCog,
  faSquarePlus,
  faSquareMinus,
  faPencil,
  faAngleRight,
  faEraser,
  faMagnifyingGlass,
  faChevronLeft,
  faChevronRight,
  faFilter,
  faRotate,
  faAnglesRight,
  faDownload,
  faBell as faBellSolid,
  faBarcode,
  faInfo,
  faCheck,
  faCheckDouble,
  faSpinner,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";

import {
  faBell,
  faFileLines,
  faCircleCheck,
  faCalendar,
  faStar,
  faClipboard,
  faFile,
  faClock,
  faXmarkCircle,
  faCircle,
  faCircleXmark,
} from "@fortawesome/free-regular-svg-icons";

import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faEye);
library.add(faEyeSlash);
library.add(faRightFromBracket);
/* menu*/
library.add(faChartColumn);
library.add(faStar);
library.add(faCartShopping);
library.add(faCalendar);
library.add(faEarthAmericas);
library.add(faClipboard);
library.add(faUpload);
library.add(faFileLines);
library.add(faFile);
library.add(faListCheck);
library.add(faUser);
library.add(faBell);

library.add(faArrowLeft);
library.add(faEllipsisVertical);
library.add(faPaperclip);
library.add(faCamera);

library.add(faBellSolid);
library.add(faAngleRight);
library.add(faPencil);
library.add(faUsers);
library.add(faClipboard);
library.add(faClipboardList);
library.add(faScaleUnbalanced);
library.add(faPenToSquare);
library.add(faTrashCan);
library.add(faPlus);
library.add(faXmark);
library.add(faBullseye);
library.add(faGear);
library.add(faCircleCheck);
library.add(faCommentDots);
library.add(faPaperPlane);
library.add(faCircleCheckSolid);
library.add(faVideo);
library.add(faCog);
library.add(faSquarePlus);
library.add(faClock);
library.add(faSquareMinus);
library.add(faLock);
library.add(faImagePortrait);
library.add(faTable);
library.add(faTableCells);
library.add(faEraser);
library.add(faMagnifyingGlass);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faStarSolid);
library.add(faCircle);
library.add(faXmarkCircle);
library.add(faCircleXmark);
library.add(faFilter);
library.add(faRotate);
library.add(faAnglesRight);
library.add(faBarcode);
library.add(faDownload);
library.add(faInfo);
library.add(faCheck);
library.add(faCheckDouble);
library.add(faSpinner);
library.add(faFilePdf);
